import i18n from "config/i18next";

i18n.addResources("es", "steps", {
  first: "Descargate la App y registrá tus datos.",
  second:
    "Anotate en los horarios disponibles que quieras, en los días y zonas que prefieras.",
  third:
    "Conectate en los horarios seleccionados y aumentá tus ganancias con cada pedido.",
  title: "En 3 simples pasos",
});
